import { Component, ViewEncapsulation } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";

@Component({
    selector: 'delete-button',
    templateUrl: './g-delete-button.component.html',
    styleUrls: ['./g-delete-button.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class AGDeleteButtonComponent implements ICellRendererAngularComp {

    constructor() { }

    private params: any;

    agInit(params: any): void {
        this.params = params;
    }

    public deleteMethod() {
        const params = {
            rowData: this.params.data
        };
        this.params.onClick(params);
    }

    refresh(): boolean {
        return false;
    }


}